import { Injectable, Type } from '@angular/core';
import { EMPTY, filter, fromEvent, map, Observable } from 'rxjs';
import { BroadcastEvent } from './broadcast-event.model';

/**
 * Broadcast data to other open browser tabs.
 */
@Injectable({ providedIn: 'root' })
export class BroadcastEventService {
  private readonly broadcastChannel =
    typeof BroadcastChannel === 'undefined' ? null : new BroadcastChannel('y42-cross-tab-event');

  broadcast(event: BroadcastEvent): void {
    this.broadcastChannel?.postMessage(event);
  }

  listen<T extends BroadcastEvent>(event: Type<T>): Observable<T['payload']> {
    if (!this.broadcastChannel) {
      console.warn(`[BroadcastEventService]: failed to initialize`);
      return EMPTY;
    }

    const eventType = new event().type;
    return fromEvent<MessageEvent>(this.broadcastChannel, 'message').pipe(
      map((messageEvent) => messageEvent.data as T),
      filter(({ type }) => type === eventType),
      map((broadcastEvent) => broadcastEvent.payload),
    );
  }
}
